import { defineStore } from "pinia";

import AuthService from "../services/auth.service";

export interface Theme {
  Accent: string;
  HighAccessibility: boolean;
  [key: string]: any;
}

const TEN_MINS = 10 * 60 * 1000;

let inflightFetch: Promise<Theme> | null = null;

export const useThemeStore = defineStore("theme", {
  state: () => ({
    theme: null as Theme | null,
    themeFetchedAt: null as number | null,
  }),

  getters: {
    accent: (state): string => state.theme?.Accent ?? "grape",
    highAccessibility: (state): boolean => state.theme?.HighAccessibility ?? false,
  },

  actions: {
    async fetchTheme(options: { force?: boolean } = {}) {
      const now = Date.now();
      const isStale = !this.themeFetchedAt || now - this.themeFetchedAt > TEN_MINS;

      if (!options.force && this.theme && !isStale) {
        return;
      }

      // Deduplicate concurrent calls: share one in-flight request
      if (inflightFetch) {
        await inflightFetch;
        return;
      }

      inflightFetch = AuthService.getTheme().then((r) => r.data);

      try {
        const data = await inflightFetch;
        this.theme = data;
        this.themeFetchedAt = now;
      } catch {
        // Keep existing cached theme: don't nuke localStorage
        // on a transient network error
      } finally {
        inflightFetch = null;
      }
    },
  },
  persist: {
    storage: typeof window !== "undefined" ? localStorage : undefined,
  },
});

export type ThemeStore = ReturnType<typeof useThemeStore>;
